import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';
import { signOut } from 'store/slices/authSlice';
const unauthorizedCode = [400, 401, 403]

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
})

// Config
const TOKEN_PAYLOAD_KEY = 'authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
	
	if (jwtToken) {
		config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`
	}

  	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

//API respone interceptor
service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		message: ''
	}
	if (error.response.status === 401) {
		notificationParam.message = 'Phiên đăng nhập đã hết hạn!'
		localStorage.removeItem(AUTH_TOKEN);
		// Dispatch action Redux để đăng xuất người dùng
		store.dispatch(signOut());
		notification.error(notificationParam);
	}

	if (error.response.status === 403) {
		notificationParam.message = 'Không có quyền truy cập'
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}
	
	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	// notification.error(notificationParam)

	return Promise.reject(error);
});

export default service;
